module.exports = __webpack_public_path__ + "img/mapbj.da129a61.png";